export type ReplaceProperty<T, K extends keyof T, NewType> = {
  [P in keyof T]: P extends K ? NewType : T[P];
};

export type MakeOptional<T, K extends keyof T> = {
  [P in keyof T as P extends K ? never : P]: T[P]; // Keep all properties except K
} & {
  [P in K]?: T[P]; // Make K optional
};

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);
